/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query LibraryDetailQuery($piece_id: ID!) {
        music_viewer {
            piece(id: $piece_id) {
                id
                ...LibraryDetailBody_piece
            }
        }
    }
`;
